"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const common_1 = require("@Const/common");
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const Footer = () => {
    const location = (0, react_router_dom_1.useLocation)();
    const currentYear = new Date().getFullYear();
    return (react_1.default.createElement("footer", { className: "footer-component", "data-testid": "footer-component" },
        react_1.default.createElement("div", { className: "info" },
            react_1.default.createElement(react_router_dom_1.Link, { to: navigation_1.default.home.root() },
                react_1.default.createElement("img", { src: common_1.ICONS.mlc_logo_black, alt: "logo" })),
            react_1.default.createElement("span", { className: "small" },
                "Mechanical Licensing Collective \u00A9 ",
                currentYear)),
        react_1.default.createElement("div", { className: "links" },
            react_1.default.createElement("a", { href: navigation_1.default.contactUs.root(), target: '_blank', className: "small", rel: "noreferrer" }, "Need Help?"),
            react_1.default.createElement("a", { href: 'https://themlc.com/', target: '_blank', className: "small", rel: "noreferrer" }, "The MLC Website"),
            location.pathname === navigation_1.default.search.root() ? (react_1.default.createElement("a", { className: "small", target: '_blank', href: "https://www.themlc.com/musicalworksdatabasetermsuse", rel: "noreferrer" }, "Musical Works Database Terms of Use")) : (react_1.default.createElement("a", { href: "https://www.themlc.com/portaltermsofuse", target: '_blank', className: "small", rel: "noreferrer" }, "Portal Terms of Use")),
            react_1.default.createElement("a", { href: "https://www.themlc.com/privacy-policy", target: '_blank', className: "small", rel: "noreferrer" }, "Privacy Policy"))));
};
exports.default = Footer;
